module.exports = __webpack_public_path__ + "static/media/ex-trading-icon1.031ad297.svg";